import React, { FunctionComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { DialogTitle, Typography } from '@material-ui/core';
import { eodItemStyles } from '../../eodItemStyles';

type ErrorProps = {
  eodReportDetails: any;
  retryEodProcess: (type: string) => void;
  showFinanacialReport: () => void;
  processErrorDialog: boolean;
  cancelEodProcess: () => void;
};
export const ErrorCaseDialog: FunctionComponent<ErrorProps> = ({
  eodReportDetails,
  retryEodProcess,
  showFinanacialReport,
  processErrorDialog,
  cancelEodProcess
}) => {
  const classes = eodItemStyles();

  return (
    <div>
      <Dialog aria-labelledby="customized-dialog-title" open={processErrorDialog} fullWidth={true}>
        <DialogTitle id="customized-dialog-title" style={{ backgroundColor: "#3d5a79" }}>
          <Typography className={classes.dialogTitleStyle}>
            Confirmation-Dialog
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <Typography className={classes.errorMessageStyle}>
              {/* Extra message not visible only on conditions: 
                   eodReportDetails.status===true :completed case
                   eodReportDetails.retryStageId===0 : No data to generate
            */}
              {eodReportDetails.message} {" "}
              {eodReportDetails.status === true ? "" :
                eodReportDetails.retryStageId !== 0 ? (
                  "Click ok to retry or cancel the process."
                ) : ""}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              {
                eodReportDetails.status === true ? showFinanacialReport() :
                eodReportDetails.retryStageId === 0 ? cancelEodProcess() :
                  retryEodProcess("retry")
              }
            }}>
            OK
                </Button>
          {/* cancel button visible only on conditions: 
                    eodReportDetails.retryStageId===0 : No data to generate
                    eodReportDetails.retryStageId===6 : Stage where businessday id generated
                    eodReportDetails.retryStageId===undefined : Completed case (6 th stage)
                 */}
          {eodReportDetails.retryStageId === 0 || eodReportDetails.retryStageId === 6 || eodReportDetails.retryStageId === undefined ?
            "" : (
              <Button
                onClick={() => { cancelEodProcess() }}>
                Cancel
              </Button>
            )}

        </DialogActions>
      </Dialog>
    </div>
  );
}
